import React, { ReactElement } from 'react';
import SignIn from '../../components/auth/SignIn';

import styles from '../styles.module.css';

const SignInPage = (props: any): ReactElement => (
  <div className={styles.auth_container}>
    <SignIn {...props} />
  </div>
);

export default SignInPage;
